<template>
  <div>
    <v-btn
      v-tooltip.top="'ใบกำกับภาษีแบบย่อ'"
      outline
      :loading="isLoadingPrint"
      :disabled="loading"
      small
      fab
      color="primary"
      @click="getShopProfile"
    >
      <i class="fas fa-file-invoice"></i>
    </v-btn>
    <vue-html2pdf
      ref="html2Pdf"
      :show-layout="false"
      :float-layout="true"
      :enable-download="false"
      :preview-modal="true"
      :paginate-elements-by-height="1100"
      :html-to-pdf-options="htmlToPdfOptions"
      :pdf-quality="2"
      :manual-pagination="false"
      pdf-format="a4"
      pdf-orientation="portrait"
      pdf-content-width="800px"
      @hasDownloaded="isLoadingPrint = false"
    >
      <section slot="pdf-content">
        <div :id="`src_img_${order.id}`" :ref="`src_img_${order.id}`">
          <div class="pt-4 pb-3 px-2">
            <v-layout class="m-0" row nowrap justify-space-between>
              <v-flex>
                <v-layout cloumn>
                  <img style="width: 150px" :src="seagull.icon" alt="seagull-icon" />
                  <div class="ml-2">
                    <div sty>บริษัท ไทยสเตนเลสสตีล จำกัด</div>
                    <div>เลขที่ 10 ซ.สุขุมวิท 61 ถ.สุขุมวิท คลองตันเหนือ วัฒนา กรุงเทพ 10110</div>
                    <div>เลขประจำตัวผู้เสียภาษีอากร 0105514003352</div>
                  </div>
                </v-layout>
              </v-flex>
              <div style="width: 160px">
                <div style="font-size: 18px; font-weight: bold">ใบกำกับภาษีแบบย่อ</div>
                <div>เลขที่ {{ `SC${createOrderYear || 'XX'}${order.id || 'XXXXXX'}` }}</div>
                <div>วันที่ {{ order.timestamp | DateFormat('DD/MM/YYYY') }}</div>
              </div>
            </v-layout>

            <div class="px-4">
              <v-layout class="px-3" style="width: 70%" column>
                <div>
                  <div class="primary--text" style="color: black">ผู้ซื้อ</div>
                  <div style="word-break: break-word">{{ taxData.tax_name }}</div>
                </div>
                <div>
                  <div class="primary--text">ที่อยู่</div>
                  <div style="word-break: break-word">
                    {{ `${taxData.tax_address}` }}
                  </div>
                  <div v-if="taxData && taxData.tax_id">
                    {{ `เลขประจำตัวผู้เสียภาษี ${taxData.tax_id}` }}
                  </div>
                </div>
                <div>
                  <div class="primary--text" style="c</div: black">เลขออเดอร์</div>
                  <div style="word-break: break-word">
                    {{ order.id }}
                  </div>
                </div>
                <div>
                  <div class="primary--text" style="color: black">ช่องทางการชำระเงิน</div>
                  <div style="word-break: break-word">
                    {{ $t(order.transactionid) }}
                  </div>
                </div>
              </v-layout>
              <v-data-table class="mb-3" :headers="headers" :items="productList" hide-actions>
                <template #items="props">
                  <tr>
                    <td class="text-xs-left">
                      {{ props.item.sku ? `SKU ${props.item.sku} ` : '' }}{{ props.item.name }}
                    </td>
                    <td class="text-xs-left">
                      {{ props.item.quantity }}
                    </td>
                    <td class="text-xs-left">
                      {{ (props.item.price / props.item.quantity).toFixed(2) }}
                    </td>
                    <td class="text-xs-left">
                      {{ props.item.price.toFixed(2) }}
                    </td>
                  </tr>
                </template>
              </v-data-table>
              <v-layout class="mt-2" row nowrap>
                <v-flex xs6 style="font-weight: bold"> หมายเหตุ </v-flex>
                <v-flex xs6>
                  <v-layout row wrap>
                    <v-flex xs6 style="font-weight: bold">รวม</v-flex>
                    <v-flex xs3>{{
                      (parseInt(order.total) - parseInt(order.shippingcharge)).toFixed(2)
                    }}</v-flex
                    ><v-flex xs3>บาท</v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs6 style="font-weight: bold">ส่วนลด</v-flex>
                    <v-flex xs3>{{ order.discount }}</v-flex
                    ><v-flex xs3>บาท</v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs6 style="font-weight: bold">ค่าจัดส่ง</v-flex>
                    <v-flex xs3>{{ order.shippingcharge }}</v-flex
                    ><v-flex xs3>บาท</v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs6 style="font-weight: bold">ราคารวมภาษีมูลค่าเพิ่ม</v-flex>
                    <v-flex xs3>{{ order.amount }}</v-flex
                    ><v-flex xs3>บาท</v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
              <v-layout row>
                <div class="py-2" style="width: 160px; text-align: center; font-weight: bold">
                  จำนวนเงินเป็นตัวอักษร
                </div>
                <v-flex class="py-2" style="border: 2px solid black">
                  <div style="text-align: center; font-weight: bold">
                    {{ THBText(order.amount) }}
                  </div>
                </v-flex>
              </v-layout>
            </div>
          </div>
        </div>
      </section>
    </vue-html2pdf>
    <v-dialog v-model="showPreview" max-width="800">
      <v-card>
        <v-card-text>
          <div style="text-align: right">
            <v-btn icon @click="showPreview = false">
              <v-icon>close</v-icon>
            </v-btn>
          </div>
          <v-card class="p-3">
            <div :id="`src_img_${order.id}`" :ref="`src_img_${order.id}`">
              <div class="pt-4 pb-3 px-2">
                <v-layout class="m-0" row nowrap justify-space-between>
                  <v-flex>
                    <v-layout cloumn>
                      <img
                        style="width: 150px"
                        src="https://zwizai.s3.amazonaws.com/ecommerce/1700804597469seagull.png"
                        alt="seagull-icon"
                      />
                      <div class="ml-2">
                        <div sty>บริษัท ไทยสเตนเลสสตีล จำกัด</div>
                        <div>
                          เลขที่ 10 ซ.สุขุมวิท 61 ถ.สุขุมวิท คลองตันเหนือ วัฒนา กรุงเทพ 10110
                        </div>
                        <div>เลขประจำตัวผู้เสียภาษีอากร 0105514003352</div>
                      </div>
                    </v-layout>
                  </v-flex>
                  <div style="width: 160px">
                    <div style="font-size: 18px; font-weight: bold">ใบกำกับภาษีแบบย่อ</div>
                    <div>เลขที่ SC66000001</div>
                    <div>วันที่ 01/01/2020</div>
                  </div>
                </v-layout>

                <div class="px-4">
                  <v-layout class="px-3" style="width: 70%" column>
                    <div>
                      <div class="primary--text">ผู้ซื้อ</div>
                      <div style="word-break: break-word">hahahahahah</div>
                    </div>
                    <div>
                      <div class="primary--text">ที่อยู่</div>
                      <div style="word-break: break-word">
                        hahahahahahhahahahahahhahahahahahhahahahahahhahahahahahhahahahahahhahahahahahhahahahahahhahahahahahhahahahahahhahahahahahhahahahahahhahahahahahhahahahahahhahahahahahhahahahahahhahahahahah
                      </div>
                    </div>
                  </v-layout>
                  <v-data-table class="mb-3" :headers="headers" :items="productList" hide-actions>
                    <template #items="props">
                      <tr>
                        <td class="text-xs-left">
                          {{ props.item.name }}
                        </td>
                        <td class="text-xs-left">
                          {{ props.item.quantity }}
                        </td>
                        <td class="text-xs-left">
                          {{ (props.item.price / props.item.quantity).toFixed(2) }}
                        </td>
                        <td class="text-xs-left">
                          {{ props.item.price.toFixed(2) }}
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                  <v-layout class="mt-2" row nowrap>
                    <v-flex xs6 style="font-weight: bold"> หมายเหตุ </v-flex>
                    <v-flex xs6>
                      <v-layout row wrap>
                        <v-flex xs6 style="font-weight: bold">รวม</v-flex>
                        <v-flex xs3>{{
                          (parseInt(order.total) - parseInt(order.shippingcharge)).toFixed(2)
                        }}</v-flex
                        ><v-flex xs3>บาท</v-flex>
                      </v-layout>
                      <v-layout row wrap>
                        <v-flex xs6 style="font-weight: bold">ส่วนลด</v-flex>
                        <v-flex xs3>{{ order.discount }}</v-flex
                        ><v-flex xs3>บาท</v-flex>
                      </v-layout>
                      <v-layout row wrap>
                        <v-flex xs6 style="font-weight: bold">ค่าจัดส่ง</v-flex>
                        <v-flex xs3>{{ order.shippingcharge }}</v-flex
                        ><v-flex xs3>บาท</v-flex>
                      </v-layout>
                      <v-layout row wrap>
                        <v-flex xs6 style="font-weight: bold">ราคารวมภาษีมูลค่าเพิ่ม</v-flex>
                        <v-flex xs3>{{ order.amount }}</v-flex
                        ><v-flex xs3>บาท</v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                    <div class="py-2" style="width: 160px; text-align: center; font-weight: bold">
                      จำนวนเงินเป็นตัวอักษร
                    </div>
                    <v-flex class="py-2" style="border: 2px solid black">
                      <div style="text-align: center; font-weight: bold">
                        {{ THBText(order.amount) }}
                      </div>
                    </v-flex>
                  </v-layout>
                </div>
              </div>
            </div>
          </v-card>
          <v-layout class="mt-3" row justify-center>
            <v-btn
              class="px-4"
              :loading="loading"
              :disabled="loading"
              color="primary"
              large
              @click="generateReport"
            >
              <i class="fa fa-download" aria-hidden="true"></i>&nbspDOWNLOAD
            </v-btn>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import api from '@/api'
import THBText from 'thai-baht-text'
import jsPDF from 'jspdf'
import * as html2canvas from 'html2canvas'
import { mapGetters } from 'vuex'
import VueHtml2pdf from 'vue-html2pdf'

import pdfMake from 'pdfmake/build/pdfmake'
import pdfFonts from '@/assets/fonts/vfs_fonts.js'
import { seagull } from './seagullBase64.js'

pdfMake.vfs = pdfFonts.pdfMake.vfs
pdfMake.fonts = {
  THSarabunNew: {
    normal: 'THSarabunNew.ttf',
    bold: 'THSarabunNew Bold.ttf',
    italics: 'THSarabunNew-Italic.ttf',
    bolditalics: 'THSarabunNew-BoldItalic.ttf'
  }
}

export default {
  components: {
    VueHtml2pdf
  },
  props: ['order'],
  data: function () {
    return {
      profile: '',
      loading: false,
      isLoadingPrint: false,
      showPreview: false,
      headers: [
        { text: 'รายการสินค้า', sortable: false },
        { text: 'จำนวน', sortable: false },
        { text: 'ราคาต่อหน่วย', sortable: false },
        { text: 'ยอดรวม', sortable: false }
      ]
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      getPageProfile: 'getPageProfile',
      addresses: 'getShippingAddress'
    }),
    seagull() {
      return seagull
    },
    taxData() {
      if (this.order && this.order.tax_address_json) {
        let taxData = null
        try {
          taxData = JSON.parse(this.order.tax_address_json)
        } catch (error) {}
        if (taxData && taxData.tax_address && taxData.tax_id && taxData.tax_name) {
          return taxData
        }
      }
      return {
        tax_address: this.order.nameaddress,
        tax_id: '',
        tax_name: this.order.first_name
      }
    },
    createOrderYear() {
      if (this.order.timestamp) {
        try {
          let fullYear = new Date(this.order.timestamp).getFullYear()
          fullYear = fullYear + 543
          fullYear = fullYear + ''
          return fullYear.substring(2, fullYear.length)
        } catch (error) {
          return 'XX'
        }
      } else {
        return 'XX'
      }
    },
    htmlToPdfOptions() {
      return {
        margin: 0,
        filename: 'ข้อมูลการติดตั้ง',
        html2canvas: {
          scrollX: 0,
          scrollY: 0,
          scale: 2,
          allowTaint: true,
          useCORS: true,
          logging: true,
          letterRendering: true
        },
        image: {
          type: 'jpeg',
          quality: 0.98
        },
        pagebreak: {
          mode: 'avoid-all',
          before: '#page2el'
        }
      }
    },
    THBText() {
      return THBText
    },
    productList() {
      if (this.order && this.order.productdetail) {
        let productList = []
        try {
          productList = JSON.parse(this.order.productdetail)
        } catch (error) {
          productList = this.order.productdetail
        }
        if (typeof productList == 'object' && productList.length) {
          return productList
        }
      }
      return []
    }
  },
  mounted: function () {},
  methods: {
    generateReport() {
      this.isLoadingPrint = true
      this.$refs.html2Pdf.generatePdf()
    },
    async downloadPdf() {
      try {
        this.$store.dispatch('loading')

        let windowHeight = window.innerHeight
        let windowWidth = window.innerWidth

        let canvasElement = document.createElement('canvas')
        canvasElement.width = windowWidth
        canvasElement.height = windowHeight

        const el = this.$refs[`src_img_${this.order.id}`]

        const canvas = await html2canvas(el, {
          canvas: canvasElement,
          width: windowWidth,
          height: windowHeight
        })
        var doc = new jsPDF('p', 'mm')
        doc.addImage(canvas, 'PNG', 10, 10)
        doc.save('sample-file.pdf')
        return
      } catch (error) {
        console.error(error)
      } finally {
        this.$store.dispatch('clear_loading')
      }
    },
    getShopProfile: async function () {
      let vm = this
      vm.loading = true
      if (!vm.selectedBot.pageid || vm.selectedBot.pageid == null) {
        vm.loading = false
        return false
      }

      if (this.addresses && this.addresses.length > 0) {
        var address = this.addresses.find((el) => {
          return el.selected
        })
        this.profile = {
          companyname: address.name,
          phoneno: address.tel,
          pageaddress:
            address.addressno +
            ' , ' +
            address.sub_district +
            ' , ' +
            address.district +
            ' , ' +
            address.province +
            ' , ' +
            address.postcode
        }
        // this.showPreview = true
        vm.generateReport()
      } else if (this.getPageProfile.pageaddress) {
        await vm.getShopAddress()
        // this.showPreview = true
        vm.generateReport()
      }

      vm.loading = false
    },
    getShopAddress() {
      var vm = this
      let data = {
        pageid: vm.selectedBot.pageid
      }
      return new Promise((resolve, reject) => {
        api.getShopProfile(data, function (error, response) {
          if (error) {
            console.error(error)
            reject()
            return
          }
          if (response.shopprofile) {
            vm.profile = response.shopprofile
            try {
              vm.profile.companyname = JSON.parse(response.shopprofile.description).companyname
              vm.profile.phoneno = JSON.parse(response.shopprofile.description).phoneno
            } catch (error) {
              vm.profile.companyname = ''
              vm.profile.phoneno = ''
            }
            resolve()
          }
        })
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/PrintAbbreviatedTaxInvoice.vue